<script>
  import {
    ChevronDownIcon,
    ChevronsDownIcon,
  } from 'vue-feather-icons'

  export default {
    components: {
      ChevronDownIcon,
      ChevronsDownIcon,
    },
    props: {
      transitionClass: {
        type: String,
        default: 'rotate-0-180',
      },
      toggle: {
        type: Boolean,
        required: true,
      },
      double: {
        type: Boolean,
        default: false,
      },
      duration: {
        type: Number,
        default: 1000,
      },
      size: {
        type: String,
        default: "1.5x",
      },
      defaultCollapsed:{
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        durationClass: '',
        transitionClassToggle: '',
      }
    },
    watch:{
      toggle(newValue, oldValue){
        if (newValue === true){
          this.transitionClassToggle = `${this.transitionClass}-collapsed`
        }else{
          this.transitionClassToggle = `${this.transitionClass}-expanded`
        }
      }
    },
    created(){
      this.durationClass = `tw-duration-${this.duration}`
      if (this.defaultCollapsed){
        this.transitionClassToggle = `${this.transitionClass}-collapsed`
      }else{
        this.transitionClassToggle = `${this.transitionClass}-expanded`
      }
    },
  }
</script>

<template>
  <transition
    :name="transitionClass"
    :enter-active-class="'tw-ease-in-out ' + durationClass"
    :leave-active-class="'tw-ease-in-out ' + durationClass"
  >
    <template v-if="double">
      <ChevronsDownIcon
        v-show="!toggle"
        v-bind="$attrs"
        class="tw-stroke-1.5 !tw-block"
        :class="transitionClassToggle"
        :size="size"
      />
    </template>
    <template v-else>
      <ChevronDownIcon
        v-show="!toggle"
        v-bind="$attrs"
        class="tw-stroke-1.5 !tw-block"
        :class="transitionClassToggle"
        :size="size"
      />
    </template>
  </transition>
</template>
